import React from 'react';
import { useTranslation } from 'react-i18next';
import {connect} from "react-redux";
import Avatar from "../../../../../../../../components/avatar";
import Button from "../../../../../../../../components/button";
import {textTruncation, upperCaseFirstLetter} from '../../../../../../../../utils';
import {contactContent} from "../../../../../../../../../actions/contactDetailsActions";
import ContactInfoOptions from "./components/contact-info-options";
import './index.css';

function ContactInfo (props) {

	let textTruncationValue = 90;
	const { t } = useTranslation();

	if(props?.setGmailAddOnData === "gmailaddon"){
		textTruncationValue = 40;
	}

    const {
        contactContent,
        setContactContent,
	    selectedContactsGroup
    } = props;

    const handleMoreDetails = () => {
        setContactContent("contact-details");
    };

    const handleSeeComments = () => {
        setContactContent("comments");
    };

    return (
        <div className="contact-info">
            <div className="d-flex">
	            <div className="position-relative">
		            <Avatar
			            className="flex-shrink-0 mr-4"
			            size={'5em'}
			            src={
				            props.imageString !== ''
					            ?
					            props.hasImage
						            ?
						            'data:image/png;base64,' + props.imageString
						            :
						            props.imageString
					            :
					            'https://lh3.googleusercontent.com/a/default-user=s96-p-k-rw-no'
			            }
		            />
		            {
		            	selectedContactsGroup.type === "directory"
			            ?
				            <svg className="directory-contact-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" xmlSpace="preserve">
					            <path fill="#001593" d="M24 0C10.745 0 0 10.745 0 24c0 13.255 10.745 24 24 24 13.255 0 24 -10.745 24 -24C48 10.745 37.255 0 24 0z"/>
					            <path d="M11.654 13.708h2.483v25.362h-2.483zm22.209 0h2.482v25.362h-2.482zm-18.284 25.362H20.554V34.673h6.892v4.397h4.974V8.93H15.579v30.139zm12.907 -28.126h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758zm-3.825 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758z" fill="#FFF"/>
				            </svg>
				        :
				            null
		            }
	            </div>
	            <div className="mr-4 flex-grow-1">
		            <h2>
			            {
				            props.givenName !== undefined
					            ?
					            props.givenName
					            :
					            ''
			            }
			            {
				            props.middleName !== undefined
					            ?
					            ' ' + props.middleName
					            :
					            ''
			            }
			            {
				            props.familyName !== undefined
					            ?
					            ' ' + props.familyName
					            :
					            ''
			            }
		            </h2>
					{
						props.company && props.jobTitle && props.department &&
						<p title={`${props.company} - ${props.jobTitle} - ${props.department}`} className="job-company">
							<strong>{props.company}</strong> — {props.jobTitle} — {props.department}
						</p>
					}
					{
						!props.company && props.jobTitle && props.department &&
						<p title={`${props.jobTitle} - ${props.department}`} className="job-company">
							{props.jobTitle} — {props.department}
						</p>
					}
					{
						!props.company && !props.jobTitle && props.department &&
						<p title={`${props.department}`} className="job-company">
							{props.department}
						</p>
					}
		            {
			            props.company && props.jobTitle && !props.department &&
			            <p title={`${props.company} - ${props.jobTitle}`} className="job-company">
				            <strong>{props.company}</strong> — {props.jobTitle}
			            </p>
		            }
		            {
			            props.company && !props.jobTitle && !props.department &&
			            <p title={props.company} className="job-company">
				            <strong>{props.company}</strong>
			            </p>
		            }
		            {
			            !props.company && props.jobTitle && !props.department &&
			            <p title={props.jobTitle} className="job-company">
				            {props.jobTitle}
			            </p>
		            }
		            {
			            props.description && <p title={props.description} className="description">{textTruncation(props.description, textTruncationValue)}</p>
		            }
	            </div>
	            <div className="mr-4">
		            <div className="d-flex">
			            {
				            (contactContent === "comments" || contactContent === "sharing-settings") &&
				            <Button onClick={handleMoreDetails} className={'btn-secondary text-nowrap'}>{t("textMoreDetails")}</Button>
			            }
			            {
				            contactContent === "contact-details" &&
				            <Button onClick={handleSeeComments} className={'btn-secondary text-nowrap'}>{t("textSeeComments")}</Button>
			            }
			            {/*
                        contactContent === "contact-details" &&
                        <Button className="d-flex align-items-center btn-outline-secondary ml-2">
                            <svg className="mr-1" width="24" height="24" viewBox="0 0 28 28" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M15.2562 8.07689L17.4998 5.83334C18.3585 4.9746 18.7879 4.54523 19.2901 4.40356C19.6452 4.30339 20.021 4.30339 20.3761 4.40356C20.8783 4.54523 21.3077 4.9746 22.1664 5.83334C23.0252 6.69207 23.4545 7.12144 23.5962 7.62366C23.6964 7.97874 23.6964 8.3546 23.5962 8.70968C23.4545 9.2119 23.0252 9.64127 22.1664 10.5L19.9489 12.7175C18.0025 11.6014 16.3868 9.99799 15.2562 8.07689ZM13.8018 9.53127L5.52282 17.8103C5.09776 18.2354 4.88523 18.4479 4.74549 18.709C4.60576 18.9701 4.54681 19.2648 4.42892 19.8543L3.64686 23.7646C3.58034 24.0972 3.54708 24.2635 3.64168 24.3581C3.73629 24.4527 3.90258 24.4194 4.23517 24.3529L4.23519 24.3529L4.23521 24.3529L8.14552 23.5709L8.14554 23.5708C8.73498 23.453 9.0297 23.394 9.2908 23.2543C9.55189 23.1145 9.76442 22.902 10.1895 22.477L18.4908 14.1756C16.5952 12.9952 14.994 11.405 13.8018 9.53127Z"
                                      fill="#4CC2F1"/>
                            </svg>
                            Edit
                        </Button>
                    */}
		            </div>
		            <ContactInfoOptions/>
	            </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                <div>
	                {
		                props.phoneNumbers
			                ?
			                props.phoneNumbers.map((phoneNumber, index) => {
				                if (index === 0) {
					                return (
						                <p key={index} className="text-nowrap mb-0">
							                <a href={"tel:"+phoneNumber.number} target="_blank" rel="noreferrer">
								                <svg className="mr-2" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									                <path d="M2.67962 1.32038L3.29289 0.707107C3.68342 0.316583 4.31658 0.316582 4.70711 0.707106L7.29289 3.29289C7.68342 3.68342 7.68342 4.31658 7.29289 4.70711L5.50048 6.49952C5.2016 6.7984 5.1275 7.255 5.31653 7.63307C6.40929 9.81858 8.18142 11.5907 10.3669 12.6835C10.745 12.8725 11.2016 12.7984 11.5005 12.4995L13.2929 10.7071C13.6834 10.3166 14.3166 10.3166 14.7071 10.7071L17.2929 13.2929C17.6834 13.6834 17.6834 14.3166 17.2929 14.7071L16.6796 15.3204C14.5683 17.4317 11.2257 17.6693 8.83698 15.8777L7.62857 14.9714C5.88504 13.6638 4.33622 12.115 3.02857 10.3714L2.12226 9.16302C0.330722 6.7743 0.568269 3.43173 2.67962 1.32038Z" fill="#314D60"/>
								                </svg>
								                {phoneNumber.number} {phoneNumber.label ? <span className="field-type">• {upperCaseFirstLetter(phoneNumber.label)}</span> : ''}
							                </a>
						                </p>
					                )
				                } else {
					                return null
				                }
			                })
			                :
			                null
	                }
                </div>
	            <div>
		            {
			            props.emailAddresses
				            ?
				            props.emailAddresses.map((emailAddress, index) => {
					            if (index === 0) {
						            return (
							            <p key={index} className="text-nowrap mb-0">
								            <a href={"mailto:"+emailAddress.email} target="_blank" rel="noreferrer">
									            <svg className="mr-2" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										            <path fillRule="evenodd" clipRule="evenodd" d="M0.0132028 4.15129C-3.38676e-10 4.69022 0 5.30205 0 6V8C0 10.8284 0 12.2426 0.87868 13.1213C1.75736 14 3.17157 14 6 14H12C14.8284 14 16.2426 14 17.1213 13.1213C18 12.2426 18 10.8284 18 8V6C18 5.30205 18 4.69022 17.9868 4.15129L9.97129 8.60436C9.36724 8.93994 8.63276 8.93994 8.02871 8.60436L0.0132028 4.15129ZM0.242967 2.02971C0.325845 2.05052 0.407399 2.08237 0.485643 2.12584L9 6.85604L17.5144 2.12584C17.5926 2.08237 17.6742 2.05052 17.757 2.02971C17.6271 1.55619 17.4276 1.18491 17.1213 0.87868C16.2426 0 14.8284 0 12 0H6C3.17157 0 1.75736 0 0.87868 0.87868C0.572448 1.18491 0.372942 1.55619 0.242967 2.02971Z" fill="#314D60"/>
									            </svg>
									            {emailAddress.email} {emailAddress.label ? <span className="field-type">• {upperCaseFirstLetter(emailAddress.label)}</span> : ''}
								            </a>
							            </p>
						            )
					            } else {
						            return null
					            }
				            })
				            :
				            null
		            }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
		contactContent: state.contactDetailsReducer.contactContent,
		setGmailAddOnData: state.profileReducer.setGmailAddOnData.checkGmailAddon,
	    selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setContactContent : (string) => {
            dispatch(contactContent(string))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfo);
